export const KIVRA_TENANT_TYPE = 'se_kivra_out'
export const KIVRA_MAIL_TYPE = 'se_kivra_in'
export const OPEN_PAYMENTS_TYPE = 'se_openpayments'
